export default "__VITE_ASSET__ee2ce5d6__"